var map = {
	"./creando-animation.png": "./src/static/assets/images/animations/creando-animation.png",
	"./creando-animation.webp": "./src/static/assets/images/animations/creando-animation.webp",
	"./ebay-animation.png": "./src/static/assets/images/animations/ebay-animation.png",
	"./ebay-animation.webp": "./src/static/assets/images/animations/ebay-animation.webp",
	"./enqsta-animation.png": "./src/static/assets/images/animations/enqsta-animation.png",
	"./enqsta-animation.webp": "./src/static/assets/images/animations/enqsta-animation.webp",
	"./fundivisa-animation.png": "./src/static/assets/images/animations/fundivisa-animation.png",
	"./fundivisa-animation.webp": "./src/static/assets/images/animations/fundivisa-animation.webp",
	"./hearthy-animation.png": "./src/static/assets/images/animations/hearthy-animation.png",
	"./hearthy-animation.webp": "./src/static/assets/images/animations/hearthy-animation.webp",
	"./kfc-animation.png": "./src/static/assets/images/animations/kfc-animation.png",
	"./kfc-animation.webp": "./src/static/assets/images/animations/kfc-animation.webp",
	"./laus-ribbon.png": "./src/static/assets/images/animations/laus-ribbon.png",
	"./laus-ribbon.webp": "./src/static/assets/images/animations/laus-ribbon.webp",
	"./listarobinson-animation.png": "./src/static/assets/images/animations/listarobinson-animation.png",
	"./listarobinson-animation.webp": "./src/static/assets/images/animations/listarobinson-animation.webp",
	"./medipremium-animation.png": "./src/static/assets/images/animations/medipremium-animation.png",
	"./medipremium-animation.webp": "./src/static/assets/images/animations/medipremium-animation.webp",
	"./ministerioconsumo-animation.png": "./src/static/assets/images/animations/ministerioconsumo-animation.png",
	"./ministerioconsumo-animation.webp": "./src/static/assets/images/animations/ministerioconsumo-animation.webp",
	"./unleash-animation.png": "./src/static/assets/images/animations/unleash-animation.png",
	"./unleash-animation.webp": "./src/static/assets/images/animations/unleash-animation.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/static/assets/images/animations sync recursive .(webp|png)$";